// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */
// @ts-nocheck
import type * as Types from '@/graphql/schema';

import fetchClient from '@/graphql/fetchMutation';
import fetchServer from '@/graphql/fetchQuery';
import gql from '@/graphql/gql';
export type StoreAbTestDataMutationVariables = Types.Exact<{
  experiments: Types.Scalars['String']['input'];
}>;


export type StoreAbTestDataMutation = { __typename?: 'Mutation', testCasesInsertUniqueTestCase?: { __typename?: 'TestCasesInsertUniqueTestCasePayload', success?: boolean } };


export const StoreAbTestDataMutationDocument = gql`
    mutation StoreAbTestDataMutation($experiments: String!) {
  testCasesInsertUniqueTestCase(input: {experiments: $experiments}) {
    success
  }
}
    `;

export const getStoreAbTestDataMutation = async (variables: StoreAbTestDataMutationVariables) => {
  return fetchClient<StoreAbTestDataMutation, StoreAbTestDataMutationVariables>(StoreAbTestDataMutationDocument, "StoreAbTestDataMutation", { variables });
}
export const getStoreAbTestDataAction = async (variables: StoreAbTestDataMutationVariables) => {
  return fetchServer<StoreAbTestDataMutation, StoreAbTestDataMutationVariables>(StoreAbTestDataMutationDocument, "StoreAbTestDataMutation", { variables });
}